import { createFileRoute, redirect } from '@tanstack/react-router';
import type { Practitioner } from '@medplum/fhirtypes';

import { medplum } from '@/config/medplum';
import { queryClient } from '@/config/queryClient';
import { getAuthUserQueryKey, fetchAuthUser } from '@/features/practitioners/hooks/useMedplumAuth';

export const Route = createFileRoute('/(authenticated)')({
	beforeLoad: async () => {
		const activeLogin = medplum.getActiveLogin();

		if (!activeLogin) {
			throw redirect({
				to: '/',
			});
		}

		if (!medplum.getProfile() && activeLogin.profile) {
			await medplum.setActiveLogin(activeLogin);
		}

		const profile = medplum.getProfile();
		if (profile?.resourceType === 'Practitioner') {
			await queryClient.ensureQueryData({
				queryKey: getAuthUserQueryKey(profile),
				queryFn: () => fetchAuthUser(medplum, profile as Practitioner),
				staleTime: Number.POSITIVE_INFINITY,
			});
		}
	},
});
